import React from "react";
import { useIntl } from "react-intl";
import { TableCell } from "@material-ui/core";

const RelatedServiceProviderDeafultAssigneeTableCell = ({
  serviceProvider,
}) => {
  const intl = useIntl();

  return (
    <TableCell>
      {intl.formatMessage({
        id: `app.userProfile.relatedServiceProviders.defaultAssignee.${serviceProvider.isDefaultAssignee}`,
      })}
    </TableCell>
  );
};

export default RelatedServiceProviderDeafultAssigneeTableCell;
